import React from "react";
import styled from "styled-components";

import Icon from "../UI/Icon/Icon";

const PanelContainer = styled.div`
  background-color: #fff;

  padding: 20px;

  border-radius: 3px;
  border: 1px solid rgba(23, 15, 48, 0.25);
  border-top: 0px;
  margin-top: 5px;
  min-height: 500px;
  height: 500px;
  max-height: 100%;
  overflow: scroll;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const IconWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  cursor: pointer;
  &:hover {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }
`;
const Heading = styled.h2`
  color: #333;
  font-size: 1.5rem;
  margin-bottom: 10px;
`;

const SummaryContainer = styled.div`
  margin: 20px;
`;

const PartContainer = styled.div`
  margin-top: 15px;
`;

const TopHeading = styled.h2`
  margin-bottom: 10px;
  color: #333;

  font-size: 1.2em;
`;

const Content = styled.p`
  font-size: 1em;
  color: ${(props) => (props.isFirst ? "black" : "#555")};
  font-weight: ${(props) => (props.isFirst ? "600" : "")};
  font-size: ${(props) => (props.isFirst ? "1.5em" : "1em")};
`;

export const SummaryPanel = ({ description, overview }) => {
  var parts = "";
  if (!overview && !description) {
    parts = [
      "Meeting's summary is not yet available, Please try again in few minutes.",
    ];
  } else if (description && !overview) {
    // parts = [
    //   "Please see the overview section. No additional detailed summary available.",
    // ];
    parts = description.split("----");
  } else if (description) {
    parts = description.split("----");
  } else {
    parts = ["There is no Summary available for this meeting"];
  }

  return (
    <PanelContainer>
      <Header>
        <TopHeading>Summary</TopHeading>
        <IconWrapper
          onClick={() => {
            navigator.clipboard.writeText(description);
          }}
        >
          <Icon
            style={{ width: "40px", height: "40px", cursor: "pointer" }}
            name="copy_icon"
          ></Icon>
        </IconWrapper>
      </Header>
      <SummaryContainer>
        {parts.map((part, index) => {
          let trimmedPart = part.trim();
          // Exclude "Detailed Summary" if it is the first part and starts with these words
          if (
            index === 0 &&
            parts.length === 1 &&
            trimmedPart.startsWith("Detailed Summary")
          ) {
            trimmedPart = trimmedPart.replace(/^Detailed Summary\s*/, "");
          }
          if (trimmedPart !== "") {
            const isHeading = index % 2 === 1; // index 1, 3, 5, etc. are now headings

            return (
              <PartContainer key={index}>
                {isHeading ? (
                  <Heading>{trimmedPart}</Heading>
                ) : (
                  <Content isFirst={index === 0 && parts.length !== 1}>
                    {trimmedPart}
                  </Content> //isFirst is being used for the first Heading, that is General Summary
                )}
              </PartContainer>
            );
          }

          return null;
        })}
      </SummaryContainer>
    </PanelContainer>
  );
};
